import React, { useMemo, useState } from "react";

// Components
// import { Header, analytics, useData, Gap, useProduct } from "../../components";
import Header from "../../../components/molecules/Header";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import Gap from "../../../components/atoms/Gap";

// Router
import { useHistory } from "react-router-dom";

// Styles
import useStyles from "./style";

// Algolia
import {
  InstantSearch,
  connectSearchBox,
  connectHits,
  connectHighlight,
  // Configure,
} from "react-instantsearch-dom";
import { indexName, searchClient } from "../../../config/Algolia";

// Material-UI
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";

// Slugify
import slugify from "slugify";
import { Typography } from "@material-ui/core";
import TypesenseInstantsearchAdapter from "typesense-instantsearch-adapter";

function SearchBox({ currentRefinement, refine }) {
  const { profil } = useData();

  const history = useHistory();

  const viewCart = () => {
    analytics.logEvent("view_cart", { user_id: profil.id });

    history.push("/cart");
  };

  return (
    <Header
      autoFocus
      type="with-back"
      placeholder="Cari Produk"
      onClick={viewCart}
      value={currentRefinement}
      onChange={(e) => refine(e.target.value)}
      onBack={() => history.goBack()}
    />
  );
}

const ConnectSearchBox = connectSearchBox(SearchBox);

function Highlight({ hit, highlight }) {
  const {configuration} = useData()
  const { search_module } = configuration

  const checkSearchEngineWithAlgolia = search_module === 'algolia' ? true : false
  const {highlightsProductName, highlightsDeskripsiSingkat, isProdukId, isBrand} = useMemo(() => {

    let myPropertyHightlight = {
      highlightProperty: "_highlightResult",
      hit,
    }

    let myObj = {
      attributeProductName: checkSearchEngineWithAlgolia ? 'nama' : 'name',
      attributeProductDesc: checkSearchEngineWithAlgolia ? 'deskripsi_singkat' : 'description',
      isProdukId: checkSearchEngineWithAlgolia ? hit?.produkId : hit?.id,
      isBrand: checkSearchEngineWithAlgolia ? hit?.brand?.nama : hit?.brand,
    }
    myObj = {
      isProdukId:myObj?.isProdukId,
      isBrand:myObj?.isBrand,
      highlightsProductName: highlight({...myPropertyHightlight, attribute:myObj?.attributeProductName}),
      highlightsDeskripsiSingkat: highlight({...myPropertyHightlight, attribute:myObj?.attributeProductDesc}),
    }
    return {...myObj}
  },[search_module, hit, highlight])

  const history = useHistory();

  const toDetailProduct = (id, title) => {
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  return (
    <>
      <ListItem
        alignItems="flex-start"
        button
        onClick={() => toDetailProduct(isProdukId, checkSearchEngineWithAlgolia ? hit.nama : hit.name)}
      >
        <ListItemAvatar>
          <Avatar
            alt={checkSearchEngineWithAlgolia ? hit.nama : hit.name}
            src={
              hit.thumbnail ? hit.thumbnail : "https://via.placeholder.com/40"
            }
            variant="rounded"
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              <div style={{flexDirection:"row"}}>
              {highlightsProductName.map(({ value, isHighlighted }, index) => {
                const style = {
                  fontWeight: isHighlighted ? "bold" : "normal",
                };

                return (
                  <span key={index} style={style}>
                    {value}
                  </span>
                );
              })}
              <span> - </span>
              <span>{isBrand ? isBrand : ""}</span>
              </div>
            </>
          }
          secondary={
            <>
              {highlightsDeskripsiSingkat.map(
                ({ value, isHighlighted }, index) => {
                  const style = {
                    fontWeight: isHighlighted ? "bold" : "normal",
                  };

                  return (
                    <span key={index} style={style}>
                      {value}
                    </span>
                  );
                }
              )}
            </>
          }
        />
      </ListItem>
      <Divider variant="fullWidth" component="li" />
    </>
  );
}

const ConnectedHighlight = connectHighlight(Highlight);

function Hits({ hits }) {
  return (
    <List style={{ width: "100%" }}>
      {hits.length > 0 ? (
        hits.map((item, index) => {
          return <ConnectedHighlight key={index} attribute="name" hit={item} />;
        })
      ) : (
        <Typography
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            marginTop: "2.5%",
          }}
        >
          Semua produk telah di tampilkan
        </Typography>
      )}
    </List>
  );
}

const ConnectedHits = connectHits(Hits);

function Browse() {
  const classes = useStyles();
  const {configuration, typesenseConfig} = useData()
  const { configuration : isConfiguration } = typesenseConfig
  let TYPESENSE_SERVE_CONFIG = {
    ...isConfiguration,
    numRetries:4,
    connectionTimeoutSeconds:1
  }

  const typesenseInstantsearchAdapter = new TypesenseInstantsearchAdapter({
    server: TYPESENSE_SERVE_CONFIG,
    additionalSearchParameters: {
      query_by:"name, description, brand, variants_1, variants_2, categories, keywords, type",
      num_typos:1,
      typo_tokens_threshold:1
    }
  })
  const {search_module} = configuration
  const [searchState, setSearchState] = useState({});
  const {isClient, isIndexName} = useMemo(() => {
    const typesense_client = typesenseInstantsearchAdapter.searchClient
    const typesense_index = process.env.REACT_APP_FIREBASE_PROD === "YES" ? 'products' : "products_dev"
    const algolia_client = searchClient
    const algolia_index = indexName

    let myObj = search_module === 'algolia' ? {
      isClient: algolia_client,
      isIndexName: algolia_index
    } : {
      isClient: typesense_client,
      isIndexName: typesense_index
    }

    return {...myObj}
  },[search_module])

  return (
    <div className={classes.root}>
      <InstantSearch
        searchClient={isClient}
        searchState={searchState}
        onSearchStateChange={setSearchState}
        indexName={isIndexName}
      >
        {/* <Configure filters={filter.toString().replaceAll(",", " ")} /> */}
        <ConnectSearchBox />
        <Gap height={45} />
        <div className={classes.productContent}>
          <ConnectedHits />
        </div>
      </InstantSearch>
    </div>
  );
}

export default Browse;
